import {Box, Modal} from "@mui/material";
import {
  DEFAULT_MAP_MODAL_BACKGROUND_COLOR,
  DEFAULT_MODAL_BOX_SHADOW,
  DEFAULT_TEXT_COLOR
} from "../../../../utils/colors";
import {ArrowForward, Close} from "@mui/icons-material";
import NoInternetIconBlue from '../../../../assets/icon-location-nointernet-selected.png';
import {MyBackButton} from "../../../common/MyBackButton";
import {MyForwardButton} from "../../../common/MyForwardButton";
import {useViewportSizes} from "../../../../hooks/useViewportSizes";
import MySecondaryModalTitle from "../../../common/MySecondaryModalTitle";
import {widgetModalFraming} from "../../../../utils/modals";
import {useContext} from "react";
import ConfigContext from "../../../../context/ConfigContext";
import rightArrowWhite from "../../../../assets/right-arrow-white.png";
import { useTranslation } from 'react-i18next';

const commonModalStyle = {
  boxShadow: DEFAULT_MODAL_BOX_SHADOW,
}

const modalStyle = {
  ...commonModalStyle,
  width: '555px',
  height: '380px',
  position: 'fixed',
  top: '20%',
  left: 'calc(50% - 290px)'
}

const mobileModalStyle = {
  ...commonModalStyle,
  width: '90%',
  height: '70%',
  position: 'fixed',
  top: '10%',
  left: '5%',
}

const boxStyle = {
  width: '100%',
  height: '85%',
  backgroundColor: DEFAULT_MAP_MODAL_BACKGROUND_COLOR,
  borderRadius: '16px',
  textAlign: 'center',
}

const subtitleStyle = {
  width: '80%',
  margin: 'auto',
  fontFamily: 'Mulish',
  fontSize: 16,
  lineHeight: '25px',
  color: DEFAULT_TEXT_COLOR,
  marginBottom: 35,
}

const xsSubtitleStyle = {
  ...subtitleStyle,
  fontSize: 13,
  lineHeight: '20px',
  marginBottom: '10px'
}

const footerStyle = {
  display: 'flex',
  flexDirection: 'row',
  maxWidth: 345,
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: 'auto'
}

const mobileFooterStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '80%',
  height: 100,
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: 'auto',
}

const xsFooterStyle = {
  display: 'flex',
  flexDirection: 'row',
  width: '90%',
  maxWidth: '310px',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '5px auto',
}

const closeButtonStyle = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  position: 'absolute',
  right: 20,
  top: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
}

const noInternetIconStyle = {
  marginTop: 40,
}

const MyNoConnectionConfirmationModal = ({
  open,
  close,
  goToLastFlowStep
}) => {
  const { t } = useTranslation();
  const config = useContext(ConfigContext);
  const {isExtraSmallSizeScreen, isMediumSizeScreen, isSmallSizeScreen} = useViewportSizes();

  const getModalStyle = () => {
    if(config.widgetMode) return widgetModalFraming(config, isExtraSmallSizeScreen || isSmallSizeScreen);
    return (isMediumSizeScreen || isSmallSizeScreen) ? mobileModalStyle : modalStyle;
  }

  const getFooterStyle = () => {
    if(isExtraSmallSizeScreen) return xsFooterStyle;
    return (isMediumSizeScreen || isSmallSizeScreen) ? mobileFooterStyle : footerStyle;
  }

  return (
    <Modal open={open}
           onClose={close}
           style={getModalStyle()}
    >
      <Box sx={boxStyle}>
        <div style={closeButtonStyle} onClick={close} className={'speedtest--modal-dismiss--hoverable'}>
          <Close fontSize={'small'} color={'disabled'}/>
        </div>
        <img style={noInternetIconStyle} src={NoInternetIconBlue} alt={t('alt.icons.noInternet')} width={42} height={42}/>
        <MySecondaryModalTitle text={t('connectionPlacement.noInternet.title')}/>
        <p style={isExtraSmallSizeScreen || isSmallSizeScreen ? xsSubtitleStyle : subtitleStyle}>{t('connectionPlacement.noInternet.subtitle')}</p>
        <div style={getFooterStyle()}>
          <MyBackButton text={t('common.buttons.cancel')}
                        onClick={close}
          />
          <MyForwardButton text={isExtraSmallSizeScreen ? t('common.buttons.confirm') : t('connectionPlacement.noInternet.button')}
                           icon={<img src={rightArrowWhite} alt={t('alt.icons.location')} width={14} height={14}/>}
                           onClick={goToLastFlowStep}
          />
        </div>
      </Box>
    </Modal>
  )
}

export default MyNoConnectionConfirmationModal;